var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.13043C11.1015 7.13043 7.13043 11.1015 7.13043 16C7.13043 20.8985 11.1015 24.8696 16 24.8696C20.8985 24.8696 24.8696 20.8985 24.8696 16C24.8696 11.1015 20.8985 7.13043 16 7.13043ZM4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4346 10.7827C14.4346 9.9183 15.1353 9.21753 15.9998 9.21753H16.0102C16.8747 9.21753 17.5754 9.9183 17.5754 10.7827C17.5754 11.6472 16.8747 12.348 16.0102 12.348H15.9998C15.1353 12.348 14.4346 11.6472 14.4346 10.7827Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3481 14.9566C12.3481 14.0921 13.0489 13.3914 13.9134 13.3914H16.0003C16.8648 13.3914 17.5655 14.0921 17.5655 14.9566V18.6087H18.0873C18.9517 18.6087 19.6525 19.3095 19.6525 20.174C19.6525 21.0384 18.9517 21.7392 18.0873 21.7392H13.9134C13.0489 21.7392 12.3481 21.0384 12.3481 20.174C12.3481 19.3095 13.0489 18.6087 13.9134 18.6087H14.4351V16.5218H13.9134C13.0489 16.5218 12.3481 15.821 12.3481 14.9566Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f774df27656be8bf938032545f22f54c.svg";
export { ForwardRef as ReactComponent };